export const normal = 'normal';
export const transparent = 'transparent';

export default {
  normal,
  transparent
};
